import { useCallback, useState } from "react"
import { MobileSearchIcon } from "../../MobileSearchIcon/MobileSearchIcon"
import { SearchPane } from "../SearchPane/SearchPane"

export function SearchContainer({ isOpen = false }: { isOpen: boolean }) {
    const [isSearchPaneOpen, setIsSearchPaneOpen] = useState(isOpen)

    const openPane = useCallback(() => {
        setIsSearchPaneOpen(true)
    }, [])

    const closePane = useCallback(() => {
        setIsSearchPaneOpen(false)
    }, [])

    return (
        <div data-testid="mobile-search-container">
            <MobileSearchIcon onClick={openPane} />
            <SearchPane isOpen={isSearchPaneOpen} onClose={closePane} />
        </div>
    )
}
